import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
});

api.interceptors.response.use(
    (res) => res,
    async (err) => {
        const orig = err.config;
        if (
            err.response?.status === 401 &&
            !orig._retry &&
            !orig.url.includes("/auth/")
        ) {
            orig._retry = true;
            try {
                await api.post("/auth/refresh");
                return api(orig);
            } catch (e) {
                // refresh failed
            }
        }
        return Promise.reject(err);
    }
);

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
    if (detail.msg) return detail.msg;
    return String(detail);
}
